
import React, { useRef } from 'react'
import { Canvas } from '@react-three/fiber'

import { OrbitControls, PerspectiveCamera } from "@react-three/drei"

import * as THREE from 'three'
import Lights from './Lights';
import Loader from './Loader';
import { Suspense } from "react";
import IPhone from './iphone';

const IphoneCanvas = ({perspective,image}) => {
    const controlRef = useRef()
    return (
        <Canvas>
            <ambientLight intensity={0.3} />

            <PerspectiveCamera makeDefault position={perspective ? perspective : [0, 0, -4]} />

            <Lights />

            <OrbitControls 
                ref={controlRef}
                makeDefault
                enableZoom={false}
                enablePan={false}
                rotateSpeed={0.4}
                target={new THREE.Vector3(0, 0 ,0)}
                onEnd={(e) => {
                console.log(controlRef.current.getAzimuthalAngle())
                // setRotationState(controlRef.current.getAzimuthalAngle())
                }}
            /> 

            <group name='large' position={[0, 0 ,0]}>
                <Suspense fallback={<Loader />}>
                    <IPhone 
                        image={image}
                        scale={[17, 17, 17]}
                    />
                </Suspense>
            </group>
        </Canvas>
    )
}

export default IphoneCanvas

